export default {"src":"/_next/static/media/redHeart.70f7348e.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};